import { module }from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'overlayClose'
        }
    }

    overlayClose() {
        let thisEl = this.el;
        toggleChildsTabindex(thisEl, '-1');

        // Focus back to trigger element
        let returnFocusEl = document.querySelector('.js-overlay-focus-back');
        if(returnFocusEl){
            document.activeElement.blur();
            returnFocusEl.focus();
        }

        // remove state active to hide overlay
        classRemove(document.querySelector('.is-overlay-active'),'is-overlay-active')
        
        // Remove content after animation
        setTimeout(function () {
            if (document.querySelector('.js-overlay-video')) {
                document.querySelector('.js-overlay-video').textContent = ''
            }
            classRemove(document.querySelector('.c-overlay-content__item.is-active'),'is-active')
        }, 400)
    }
}
